module.exports = __webpack_public_path__ + "static/media/haight1.166ab32a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/photos/haight1.jpg
// module id = 221
// module chunks = 0